import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

import logo from "../logo.png";
import { ProductConsumer } from "../context";

function Navbar() {
  return (
    <React.Fragment>
      <nav className="navbar navbar-expand-sm navbar-light bg-white px-sm-5">
        <ul className="navbar-nav align-items-center mr-auto">
          <li className="nav-item ml-5">
            <Link to="/" className="nav-link">
              Products
            </Link>
          </li>
        </ul>

        <Link to="/">
          <img src={logo} alt="blueberry-logo" className="navbar-brand" />
        </Link>

        <Link to="/cart" className="ml-auto">
          <CartContainer className="btn">
            <FontAwesomeIcon icon={faShoppingCart} className='shopping-cart' />
            <ProductConsumer>
              {({ cartCount }) => <span className="ml-2">{cartCount}</span>}
            </ProductConsumer>
          </CartContainer>
        </Link>
      </nav>
    </React.Fragment>
  );
}

const CartContainer = styled.button`
  :hover .shopping-cart,
  :hover span {
    color: var(--mainYellow);
    transition: all 0.3s;
  }
`;

export default Navbar;
